import { render, staticRenderFns } from "./image-box.vue?vue&type=template&id=c8e35636&scoped=true&"
import script from "./image-box.vue?vue&type=script&lang=js&"
export * from "./image-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e35636",
  null
  
)

export default component.exports